import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';

export function useGetAdviceFoliarReport(id: string) {
	const forBinding = useForBindingId();
	return useQuery({
		queryKey: ['foliar', 'report', id],
		queryFn: async () => {
			const { data } = await api.get(`/advices/foliar-application/report/${id}`, {
				responseType: 'blob', params: { forBinding },
			});

			return data;
		},
		enabled: !!id,
	});
}
